function prunePingRecords(records, nowMs, maxAgeMs, limit) {
  if (!(records instanceof Map)) return;
  const currentMs = Number(nowMs) || Date.now();
  const ageLimit = Math.max(0, Number(maxAgeMs) || 0);
  const sizeLimit = Math.max(1, Math.floor(Number(limit) || 1));
  for (const [id, sentAt] of records) {
    if (currentMs - Number(sentAt) > ageLimit) records.delete(id);
  }
  while (records.size >= sizeLimit) {
    const oldestId = records.keys().next().value;
    if (oldestId === undefined) break;
    records.delete(oldestId);
  }
}

export { prunePingRecords };
